import { customHtml } from '@yola/ws-sdk';

const { fieldNames: customCodeFieldNames } = customHtml.constants;

const fieldNames = {
  NAME: 'name',
  PATH: 'path',
  HTML_LOCALE: 'htmlLocale',
  DISPLAY_IN_NAVIGATION: 'displayInNavigation',
  PASSWORD: 'password',
  TITLE: 'title',
  USE_PAGE_NAME_FOR_PAGE_TITLE: 'usePageNameForPageTitle',
  USE_BUSINESS_NAME_IN_PAGE_TITLE: 'useBusinessNameInPageTitle',
  PREVENT_INDEXING: 'preventIndexing',
  DESCRIPTION: 'description',
  KEYWORDS: 'keywords',
  OG_TITLE: 'openGraphTitle',
  USE_PAGE_TITLE_FOR_OG_TITLE: 'usePageTitleForOgTitle',
  OG_DESCRIPTION: 'openGraphDescription',
  USE_PAGE_DESCRIPTION_FOR_OG_DESCRIPTION: 'usePageDescriptionForOgDescription',
  OG_IMAGE: 'openGraphImage',
  CANONICAL_URL: 'canonicalUrl',
  USE_PAGE_URL_FOR_CANONICAL_URL: 'usePageUrlForCanonicalUrl',
  ...customCodeFieldNames,
};

const FIELD_NAMES_IN_GENERAL_TAB = [
  fieldNames.NAME,
  fieldNames.PATH,
  fieldNames.HTML_LOCALE,
  fieldNames.DISPLAY_IN_NAVIGATION,
  fieldNames.PASSWORD,
];

const FIELD_NAMES_IN_SEO_TAB = [
  fieldNames.TITLE,
  fieldNames.USE_PAGE_NAME_FOR_PAGE_TITLE,
  fieldNames.USE_BUSINESS_NAME_IN_PAGE_TITLE,
  fieldNames.PREVENT_INDEXING,
  fieldNames.DESCRIPTION,
  fieldNames.KEYWORDS,
  fieldNames.CANONICAL_URL,
  fieldNames.USE_PAGE_URL_FOR_CANONICAL_URL,
];

const FIELD_NAMES_IN_OPEN_GRAPH_TAB = [
  fieldNames.OG_TITLE,
  fieldNames.USE_PAGE_TITLE_FOR_OG_TITLE,
  fieldNames.OG_DESCRIPTION,
  fieldNames.USE_PAGE_DESCRIPTION_FOR_OG_DESCRIPTION,
  fieldNames.OG_IMAGE,
];

const FIELD_NAMES_IN_CUSTOM_CODE_TAB = [
  fieldNames.HEAD_CODE,
  fieldNames.HEADER_CODE,
  fieldNames.FOOTER_CODE,
];

export default fieldNames;
export {
  FIELD_NAMES_IN_GENERAL_TAB,
  FIELD_NAMES_IN_SEO_TAB,
  FIELD_NAMES_IN_OPEN_GRAPH_TAB,
  FIELD_NAMES_IN_CUSTOM_CODE_TAB,
};
